module.exports = __webpack_public_path__ + "img/product-icon.90072ee5.png";